// Delete job application. ************************************************************************
// pathname: /v1/applied-jobs/{jobSlug}
// method:   DELETE
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/**
 * @description SWR mutation: DELETE the current user's application to a job. Response status ok: 204.
 * Only available to an admin impersonating the talent, while the application is unviewed and at most 3 days old.
 * @param jobSlug - string. The job slug.
 * @param locale - string. The locale to use for the request.
 * @param successCallback - function. The callback to call on success.
 * @param successToastText - string. The text to show in the success toast.
 */
export const useSwrDeleteJobApplication = (jobSlug: string, locale: string, successCallback?: () => void, successToastText?: string) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: `/v1/applied-jobs/${jobSlug}`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
